// Caches the last effective language `EffectiveLanguageService` resolved, so the pre-login
// bootstrap (`app.module.ts`) can render a returning user's language immediately instead of
// flashing the tenant default while the profile call round-trips. This is a best-guess only -
// never authoritative - the resolver always re-confirms against the backend once the user is
// known, and overwrites the cache with whatever it finds (see ADR 010 PR #1/#2).
const LANGUAGE_CACHE_KEY = "cerrix-lang";

export function readCachedLanguage(): string | null {
    try {
        return window.localStorage.getItem(LANGUAGE_CACHE_KEY);
    } catch {
        return null;
    }
}

export function writeCachedLanguage(lang: string): void {
    try {
        window.localStorage.setItem(LANGUAGE_CACHE_KEY, lang);
    } catch {
        // Ignore storage failures (e.g. private mode); the cache is best-effort.
    }
}

// The navbar i18n tools' pseudo-locale checkbox. Independent of LANGUAGE_CACHE_KEY: this is a
// sticky on/off toggle, not a one-shot lang value. When off, the app falls back to the normal
// profile/tenant-default/English flow.
const PSEUDO_ENABLED_KEY = "cerrix-pseudo-enabled";

export function isPseudoEnabled(): boolean {
    try {
        return window.localStorage.getItem(PSEUDO_ENABLED_KEY) === "true";
    } catch {
        return false;
    }
}

export function setPseudoEnabled(enabled: boolean): void {
    try {
        window.localStorage.setItem(PSEUDO_ENABLED_KEY, String(enabled));
    } catch {
        // Ignore storage failures (e.g. private mode); toggle is best-effort.
    }
}
